import { Layout } from "antd";
import { HeaderMenu, LoadingOverlay, PageFooter, ProhibitedArea } from "components";
import AppPaths from "constants/appPaths";
import PropTypes from "prop-types";
import { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import actions from "store/actions";

const { Header, Content, Footer } = Layout;

function AuthenticatedPageWrapper(ComposedComponent, wrapperProps = {}) {
    class Authentication extends Component {
        constructor(props) {
            super(props);
            this.state = {
                redirectToLogin: false,
                fetchingTenant: props.tenant ? false : true,
                tenantPermissionDenied: false,
            };
        }

        componentDidMount() {
            // From componentWillMount (deprecated)
            this.props.getUserAndTenant();
            this.props.heartbeatStart();
            if (!wrapperProps.requireUserBusinessAreas) {
                this.props.getUserBusinessAreas();
                this.props.getUserActiveBusinessArea();
            }

            if (wrapperProps.activeBusinessAreaBasePath) {
                let pathParams = this.props.match.params;
                let activeBusinessAreaBasePath = wrapperProps.activeBusinessAreaBasePath;
                for (let param in pathParams) {
                    if (param !== "businessarea") {
                        activeBusinessAreaBasePath = activeBusinessAreaBasePath.replace(`:${param}`, pathParams[param]);
                    }
                }
                this.props.setActiveBusinessAreaPath(activeBusinessAreaBasePath);
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.getUserTenantResult !== prevProps.getUserTenantResult || this.props.userLogoutResult !== prevProps.userLogoutResult) {
                if (this.props.getUserTenantResult.success === false || this.props.userLogoutResult.success) {
                    if (this.props.getUserTenantResult.code === "PERMISSION_DENIED") {
                        this.setState({
                            fetchingTenant: false,
                            tenantPermissionDenied: true,
                        });
                    } else {
                        this.setState({
                            redirectToLogin: true,
                            userLogOut: this.props.userLogoutResult !== prevProps.userLogoutResult && this.props.userLogoutResult.success,
                        });
                    }
                } else if (!this.props.tenant) {
                    this.setState({
                        fetchingTenant: false,
                        tenantPermissionDenied: true,
                    });
                } else if (this.props.tenant.name === this.props.match.params.tenant || !this.props.match.params.tenant) {
                    this.setState({
                        fetchingTenant: false,
                        tenantPermissionDenied: false,
                    });
                } else {
                    this.setState({
                        fetchingTenant: false,
                        tenantPermissionDenied: true,
                    });
                }
            }
        }

        componentWillUnmount() {
            this.props.heartbeatStop();
            this.props.setActiveBusinessAreaPath(null);
        }

        getLoginPath = () => {
            let loginPath = AppPaths.LOGIN;
            if (!this.state.userLogOut && this.props.location && this.props.location.pathname) {
                let redirectPath = this.props.location.pathname;
                if (this.props.location.search) {
                    redirectPath = encodeURI(`${redirectPath}${this.props.location.search}`);
                }

                loginPath = `${loginPath}?redirect_to=${redirectPath}`;
            }
            return loginPath;
        };

        render() {
            if (this.state.redirectToLogin) {
                return <Redirect to={this.getLoginPath()}></Redirect>;
            }

            return (
                <>
                    {this.state.fetchingTenant || this.props.isLoadingCustomizationData ? (
                        <LoadingOverlay busy={true} message="Please wait..."></LoadingOverlay>
                    ) : this.state.tenantPermissionDenied === false ? (
                        <>
                            <Layout className="page-layout">
                                {wrapperProps.showHeader === false ? (
                                    <></>
                                ) : (
                                    <Header className="layout-header">
                                        <HeaderMenu {...this.props} {...wrapperProps} companyName={this.props.customizationData?.companyName}></HeaderMenu>
                                    </Header>
                                )}

                                <Content style={{ overflow: "hidden" }} className="page-content">
                                    <div className="page-container">
                                        <ComposedComponent {...this.props} {...wrapperProps} />
                                    </div>
                                </Content>
                                {wrapperProps.showFooter === false ? (
                                    <></>
                                ) : (
                                    <Footer className="layout-footer">
                                        <PageFooter
                                            sloganFooter={
                                                this.props.customizationData?.sloganFooter ? this.props.customizationData.sloganFooter : "Intelligent choice for good customer data"
                                            }
                                        ></PageFooter>
                                    </Footer>
                                )}
                            </Layout>
                        </>
                    ) : (
                        <ProhibitedArea />
                    )}
                </>
            );
        }
    }

    Authentication.propTypes = {
        tenant: PropTypes.object,
        activeBusinessAreaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        userBusinessAreas: PropTypes.array,
        user: PropTypes.object,
        cognitoUser: PropTypes.object,
        getUserTenantResult: PropTypes.object,
        userLogoutResult: PropTypes.object,
        customizationData: PropTypes.shape({
            companyName: PropTypes.string,
            sloganFooter: PropTypes.string,
        }),
        getUserAndTenant: PropTypes.func.isRequired,
        userLogout: PropTypes.func.isRequired,
        getUserBusinessAreas: PropTypes.func.isRequired,
        getUserActiveBusinessArea: PropTypes.func.isRequired,
        setActiveBusinessAreaPath: PropTypes.func.isRequired,
        heartbeatStart: PropTypes.func.isRequired,
        heartbeatStop: PropTypes.func.isRequired,
        match: PropTypes.shape({
            params: PropTypes.object.isRequired,
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
        }),
        history: PropTypes.object,
        isLoadingCustomizationData: PropTypes.bool,
        getCustomizationResult: PropTypes.object,
    };

    return Authentication;
}

const mapStateToProps = (state) => {
    return {
        tenant: state.userLogin.tenant,
        activeBusinessAreaId: state.home.activeBusinessAreaId,
        userBusinessAreas: state.home.businessAreas,
        user: state.userLogin.user,
        cognitoUser: state.userLogin.cognitoUser,
        getUserTenantResult: state.userLogin.getUserTenantResult,
        userLogoutResult: state.userLogin.userLogoutResult,
        customizationData: state.tenancyCustomization.customizationData,
        isLoadingCustomizationData: state.tenancyCustomization.loading,
        getCustomizationResult: state.tenancyCustomization.getCustomizationResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserAndTenant: () => dispatch(actions.getUserAndTenantRequest()),
        userLogout: () => dispatch(actions.userLogoutRequest()),
        getUserBusinessAreas: () => dispatch(actions.getUserBusinessAreasRequest()),
        getUserActiveBusinessArea: () => dispatch(actions.getUserActiveBusinessAreaRequest()),
        setActiveBusinessAreaPath: (activeBusinessAreaPath) => dispatch(actions.setActiveBusinessAreaPathRequest(activeBusinessAreaPath)),
        heartbeatStart: () => dispatch(actions.heartbeatStart()),
        heartbeatStop: () => dispatch(actions.heartbeatStop()),
    };
};

// Create a higher-order component (HOC) factor
const withAuthenticatedPageWrapper = (composedComponent, props = {}) =>
    connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthenticatedPageWrapper(composedComponent, props)));

export default withAuthenticatedPageWrapper;
